import { render, staticRenderFns } from "./ResetPasswordSubmitPage.vue?vue&type=template&id=219fec96&scoped=true&"
import script from "./ResetPasswordSubmitPage.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordSubmitPage.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordSubmitPage.vue?vue&type=style&index=0&id=219fec96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219fec96",
  null
  
)

export default component.exports